import { collection, query, where, orderBy, getDocs, limit } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface AuditLogEntry {
  id:          string;
  userId:      string;
  action:      string;
  performedBy: string;
  field?:      string | null;
  before?:     unknown;
  after?:      unknown;
  timestamp:   any;
}

// Fetch the most recent audit entries for a given user.
// Returns newest-first. Capped at `max` rows (default 50) — the timeline UI
// renders all of them; admin can request a fresh page beyond that later.
export async function fetchUserAuditLogs(userId: string, max = 50): Promise<AuditLogEntry[]> {
  const q = query(
    collection(db, 'userAuditLogs'),
    where('userId', '==', userId),
    orderBy('timestamp', 'desc'),
    limit(max),
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() } as AuditLogEntry));
}
